<template>
  <main>
    <div class="row">
      <div
        class="col-md-10 offset-md-1 col-lg-10 offset-lg-1 col-sm-12 col-xs-12 mb-1"
        v-for="(chart, i) in apply"
        :key="`chart_${i}`"
      >
        <component
          :idUsuario="usuario.id"
          :ref="chart.component"
          :is="chart.component"
          v-bind="chartsData[chart.component]"
        ></component>
      </div>
    </div>
  </main>
</template>
<script>
import uterineHeightGraph from "../base/baseGraficasEmbarazo/uterineHeightGraph";
import presionArterialGraph from "../base/baseGraficasEmbarazo/presionArterialGraph";
import imcGraph from "../base/baseGraficasEmbarazo/imcGraph";
import dayjs from "dayjs";
//import {isEmpty} from "lodash";
import graficasService from "@/services/graficasService";
import embarazoService from "../../../services/embarazoService";

export default {
  props: ["usuario", "idHistoria"],
  components: { uterineHeightGraph, presionArterialGraph, imcGraph },
  data() {
    return {
      charts: [
        {
          name: "ALTURA UTERINA",
          component: "uterineHeightGraph",
        },
        {
          name: "PRESION ARTERIAL",
          component: "presionArterialGraph",
        },
        {
          name: "IMC",
          component: "imcGraph",
          start: 2,
          end: 5,
          gender: "F",
        },
      ],
      data_altura_uterina: {},
      data_presion_arterial: {},
      data_imc: {},
      obs_altura_uterina: "",
      obs_presion_arterial: "",
      obs_imc: "",
    };
  },

  async created() {
    this.LoaderSpinnerShow();
    await this.cargarAlturauterina();
    await this.cargarPresionArterial();
    await this.cargarPesoTalla();
    await this.getObservations();
    this.LoaderSpinnerHide();
  },
  methods: {
    async save() {
      let charts = [];

      this.apply.forEach((x) => {
        charts.push(this.$refs[x.component][0].export());
      });

      await graficasService.store({
        id_historia: this.idHistoria,
        charts: charts,
      });

      /*  for (let index = 0; index < charts.length; index++) {
        await graficasService.store({
          id_historia: this.idHistoria,
          charts: charts[index],
        });
      } */
    },
    async cargarAlturauterina() {
      const response = await embarazoService.showAlturaUterina(this.usuario.id);
      this.data_altura_uterina = response.data;
    },
    async cargarPresionArterial() {
      const response = await embarazoService.showPresionArterial(
        this.usuario.id
      );
      this.data_presion_arterial = response.data;
    },
    async cargarPesoTalla() {
      const response = await embarazoService.showPesoTalla(this.usuario.id);
      this.data_imc = response.data;
    },

    async getObservations() {
      const response = await graficasService.show(this.idHistoria);
      const observations = response.data; // Datos obtenidos del servicio

      // Agregar observaciones a los datos correspondientes
      observations.forEach((obs) => {
        
        if (obs.code === "alturaUterina") {
          this.obs_altura_uterina = obs.observations || "";
        } else if (obs.code === "presionArterial") {
          this.obs_presion_arterial = obs.observations || "";
        } else if (obs.code === "eva_nut") {
          this.obs_imc = obs.observations || "";
        }
        
      });
    },
  },
  computed: {
    edad: function () {
      const now = dayjs();
      return now.diff(this.usuario.fecha_nacimiento, "years");
    },
    edadEnMeses: function () {
      const now = dayjs();
      return now.diff(this.usuario.fecha_nacimiento, "month", true);
    },
    apply() {
      return this.charts;
    },
    chartsData() {
      return {
        uterineHeightGraph: {
          data_chart: this.data_altura_uterina,
          label: "Altura Uterina",
          code: "alturaUterina",
          observacionesGraphs: this.obs_altura_uterina
        },
        presionArterialGraph: {
          data_chart: this.data_presion_arterial,
          label: "PRESION ARTERIAL",
          code: "presionArterial",
          observacionesGraphs: this.obs_presion_arterial
        },
        imcGraph: {
          data_imc: this.data_imc,
          name: "IMC",
          x: 20,
          y: 23,
          code: "eva_nut",
          observacionesGraphs: this.obs_imc
        },
      };
    },
  },
};
</script>
